<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <!-- 只有是永城市才显示警校互动 -->
        <el-button
          v-if="regionCode == 411481"
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="add"
          >新增互动</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
          :data="tableData"
          height="100%"
          class="table_box"
        >
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderId"
            label="工单"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="互动人"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="eventContent"
            label="事件"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="content"
            label="内容"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="生成时间"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              {{ $Common.dateFormatDateTwo(scope.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="policeName"
            label="民警"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="timeLimit"
            label="时限"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <div>{{ scope.row.timeLimit }} 小时</div>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <el-tag
                type="warning"
                size="small"
                v-if="scope.row.orderStatus == 1"
              >
                进行中
              </el-tag>
              <el-tag
                type="success"
                size="small"
                v-if="scope.row.orderStatus == 2"
              >
                已结束
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-link
                type="primary"
                @click="sel(scope.row.orderId)"
                :underline="false"
                >详情</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="reqData.pageNum"
          :page-size="reqData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <interact-add :resize="resize" @getList="getList"></interact-add>
    <interact-detail
      :detailResize="detailResize"
      :orderId="orderId"
    ></interact-detail>
  </div>
</template>

<script>
import interactAdd from "./components/interactAdd.vue";
import interactDetail from "./components/interactDetail.vue";
export default {
  name: "extraInteract",
  components: {
    interactAdd,
    interactDetail
  },
  props: {},
  data() {
    return {
      fileUrl: this.$store.state.config.fileUrl,
      reqData: {
        type: 1,
        identity: 1,
        userId: this.$store.getters.getUserInfo.userId,
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0,
      resize: 0,
      detailResize: 0,
      orderId: 0,
      regionCode: ""
    };
  },
  created() {
    this.getList();
    this.regionCode = this.userInfo.loginId.slice(0, 6);
    // console.log(this.regionCode, 222);
  },
  mounted() {},
  watch: {},
  computed: {
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  methods: {
    searchData() {
      this.reqData.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      this.getList();
    },
    add() {
      this.resize++;
    },
    sel(id) {
      this.orderId = id;
      this.detailResize++;
    },
    async getList() {
      let req = this.reqData;
      let res = await this.$Http.getInteractList(req);
      if (res.code == 200) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.dialog-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-footer {
  text-align: center;
}
</style>
